<template src="./archivio.html"></template>

<script>
//Importo le funzioni dal file 'api.home.js'
import {
    carica_file_filtri,
    get_file,
    elimina_file,
    getFileCliente,
    download_file,
    elimina_cartella,
    archivia_cliente
} from "@/api/api.dati.js";

import DialogCartella from "@/components/dialog/DialogCartella.vue";
import DialogRenameDirectory from "@/components/dialog/DialogRenameDirectory.vue";
import DialogSpostaElemento from "@/components/dialog/DialogSpostaElemento.vue";
import DialogAnteprimaDocumento from "@/components/dialog/DialogAnteprimaDocumento.vue";

import mixinArchivio from "../../utils/dati/mixinArchivio";

export default {
    components: { DialogCartella, DialogRenameDirectory, DialogSpostaElemento, DialogAnteprimaDocumento },

    props: {
        compCode: { type: String, default: "" },
    },
    mixins: [mixinArchivio],

    data: () => ({
        //per caricamento file
        file: [],//null
        fileSupp: [],
        countFile: 0,
        //per i nomi dei file e cartelle
        listaDati: [],
        //Per la dialog
        dialog: false,
        nomeCartella: "",
        selectedItem: -1,
        loading: false,

        selectedRow: null,
        previousRow: {},
        selectedRowSupp: null,
        selectedRowSuppBack: null,
        codeCartellaOrigine: "",
        pathOrigine: "",
        posizioneUrl: "",
        pathIndietro: "",

        //visualizzazione cartelle/file
        flagStyle: true,

        //alert
        successFile: false,
        errorFile: false,
        successFileDel: false,
        errorFileDel: false,
        successDir: false,
        errorDir: false,

        isPulsating: false,
        refreshFlag: false,

        opzioni: [],
        opzioniFolder: null,

        dialogRenameDir: false,
        DirectoryRename: null,
        TipoDirectoryRename: -1,

        menuView: false,

        dialogSposta: false,
        elementoDaSpostare: null,

        dialogAnteprima: false,
        elementoAnteprima: null,

        ricercaRagioneSociale: "",
        filtroCertificazioni: [],
        opzioniCertificazione: [
            { text: "FSC", value: "certificazioneFSC" },
            { text: "PEFC", value: "certificazionePEFC" },
            { text: "FPC", value: "certificazioneFPC" },
            { text: "ISO", value: "certificazioneISO" },
        ],
    }),

    methods: {
        // Percorso relativo (mai l'indirizzo reale del server di storage, riservato all'api)
        // della cartella corrente, usato per costruire le richieste verso il server
        radiceConPosizione() {
            return this.posizioneUrl ? `UserFile/${this.posizioneUrl}` : "UserFile";
        },

        //Funzione per caricamento file
        async uploadFile() {
            this.loading = true;
            let upload = false;

            for (let i = 0; i < this.fileSupp.length; i++) {
                let par = ""; let path = ""; let spaziNomeFile = false;

                //controllo se il nome contiene spazi
                //spaziNomeFile = this.controlloNomeFile(this.fileSupp[i].name);

                if (!spaziNomeFile) {
                    let formData = new FormData();
                    formData.append("file", this.fileSupp[i]);

                    path = this.radiceConPosizione() + "/" + this.fileSupp[i].name;
                    //else path = this.controlloPathFileCaricato(this.pathIndietro);

                    par = "?path=" + encodeURIComponent(path)
                    let res = await carica_file_filtri(formData, par);

                    if (res.data.message != "OK") {
                        upload = true;
                        this.$toast.alert("Errore! Impossibile caricare il file: " + this.fileSupp[i].name + ". " + res.data.message);
                        break;
                    }

                    if (i == this.fileSupp.length - 1)
                        if (!upload) {
                            await this.getResources(true, false, true); //carico risorse aggiornate
                            this.successFile = true;
                            setTimeout(() => {
                                this.successFile = false;
                            }, 3000);
                        } else {
                            this.errorFile = true;
                            setTimeout(() => {
                                this.errorFile = false;
                            }, 3000);
                        }
                } else this.$toast.alert("Errore! Impossibile caricare il file. Sono presenti degli spazi nel nome file");
            }

            this.loading = false;
        },

        /* controlloNomeFile(nameFile) {
            let spaziNomeFile = false
            if (nameFile.includes(" ")) spaziNomeFile = true;
            return spaziNomeFile;
        }, */

        handleFileChange(e) {
            this.file = e.target.files[0];
        },

        async getResources(value, back, refreshAfterUpload) {
            this.loading = true;

            let par = { path: "", refresh: refreshAfterUpload == true ? true : false };
            let lunghezzaUrl = 0;
            this.resetCampi();

            if (back) {
                let path = this.radiceConPosizione();
                if (path != "") path = this.controlloPathFileEliminato(path); //controllo se nel path è presente nome file
                par.path = path;
                lunghezzaUrl = path.slice(0, path.length).length;
            }
            else {
                if (this.selectedRow != null) {
                    let path = this.selectedRow.path.split("/");
                    path = this.controlloPathFileEliminato(path); //controllo se nel path è presente nome file
                    par.path = path.slice(0, path.length).join('/');
                    lunghezzaUrl = path.slice(0, path.length).length;
                } else {
                    let path = this.pathIndietro.split("/");
                    if (path != "") path = this.controlloPathFileEliminato(path); //controllo se nel path è presente nome file
                    par.path = path.slice(0, path.length).join('/');
                    lunghezzaUrl = path.slice(0, path.length).length;
                }
            }
            if (value && lunghezzaUrl > 6) par.refresh = true;
            if (refreshAfterUpload) par.path = this.radiceConPosizione();

            this.listaDati = [];
            let res = await get_file(par);
            if (res.data.length > 0 && res.data != []) {
                this.listaDati = res.data;
                if (this.listaDati.length > 0) {
                    //salvo il path di origine delle risorse
                    this.pathOrigine = this.listaDati[0].path;
                }
                this.setPosUrl(value);
            }
            //ordino cartelle per Ragione Sociale
            this.orderListaCartelle();

            this.loading = false;
        },

        orderListaCartelle() {
            this.listaDati.sort((a, b) => {
                if (!a.cliente) return 1;
                if (!b.cliente) return -1;
                return a.cliente.localeCompare(b.cliente, 'it', { sensitivity: 'base' });
            });
        },

        controlloPathFileEliminato(path) {
            if (path[path.length - 1].includes(".")) path.pop();
            return path;
        },

        controlloPathFileCaricato(path) {
            let url = path.split("/");
            if (url[url.length - 1] == url[url.length - 2]) path = url.slice(0, -1).join("/");
            else path = url.join("/");
            return path;
        },

        resetCampi() {
            /* this.codeCartellaOrigine = "";
            this.selectedItem = -1;
            this.selectedRow = null;
            this.selectedRowSupp = null;
            thi.selectedRowSuppBack = null;
            this.pathOrigine = ""; */
            this.file = [];
            this.fileSupp = [];
            this.countFile = 0;
            this.flagBack = false;
            //this.file = null;
            this.successFile = false;
            this.errorFile = false;
            this.successFileDel = false;
            this.errorFileDel = false;
            this.successDir = false;
            this.errorDir = false;
            this.pathIndietro = "";
            this.opzioni = this.opzioniComplete();
            this.opzioniFolder = null;
            this.DirectoryRename = null;
        },

        opzioniComplete() {
            let opzioni = this.getOpzioni();
            if (this.getRole === "admin") opzioni = [...opzioni, { Opzione: 3, Nome: "Sposta" }];
            return opzioni;
        },

        anteprimaFile(oggetto) {
            if (oggetto.tipo != "file") return;

            const estensione = (oggetto.estensione || "").toLowerCase();
            if (estensione === ".docx" || estensione === ".xlsx" || estensione === ".xls" || estensione === ".csv") {
                // anteprima lato client (nessun link pubblico esposto, il file passa dal download autenticato)
                this.elementoAnteprima = oggetto;
                this.dialogAnteprima = true;
                return;
            }

            let ur = oggetto.path.split('/').map(encodeURIComponent).join('/');
            window.open("https://www.wpcoc.it/data/" + ur, "_blank");
        },

        async scaricaFile(oggetto, anteprima) {
            //controllo se oggetto selezionato è un file
            if (oggetto.tipo != "file") return;

            this.loading = true;
            let par = "?path=" + encodeURIComponent(oggetto.path)
            const response = await download_file(par);
            //ricavo il tipo di file (estensione file)
            let url = response.config.url.split("%5C");
            let tipoFile = url[url.length - 1];
            tipoFile = tipoFile.split(".").pop();
            //setto il nome del file scaricato
            let nomeFile = oggetto.nome;
            if (oggetto.revisione > 0) nomeFile = oggetto.nome + "_" + oggetto.revisione;
            //download file
            this.downloadFile(response.data, tipoFile, nomeFile, anteprima);

            this.loading = false;
        },

        async downloadFile(data, tipoFile, nomeFile, anteprima) {
            let mimeTypes = this.getMimeTypes();
            let blob = new Blob([data], { type: mimeTypes[tipoFile] || "application/octet-stream" });
            let url = window.URL.createObjectURL(blob);

            //if (!anteprima) {
            let a = document.createElement("a");
            a.href = url;

            a.download = nomeFile;//+ `.${tipoFile}`;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        },

        async eliminaFile(oggetto) {
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare il file: <br><b>" + oggetto.nome + oggetto.estensione + "</b>?"
            );
            if (!confirm) return;

            let par = "?path=" + encodeURIComponent(this.selectedRow.path)
            let res = await elimina_file(oggetto, par);

            if (res.data == "OK") {
                this.getResources(true, false, true);
                this.successFileDel = true;
                setTimeout(() => {
                    this.successFileDel = false;
                }, 3000);
            } else {
                this.errorFileDel = true;
                setTimeout(() => {
                    this.errorFileDel = false;
                }, 3000);
            }
            //else this.$toast.alert("Errore! Impossibile eliminare il file. " + res.data);
        },

        selectRow(i) {
            Object.assign(this.previousRow, this.selectedRow);
            this.selectedRow = i;
            if (this.selectedRow.tipo != "file") {
                if (this.codeCartellaOrigine == "") {
                    this.codeCartellaOrigine = this.selectedRow.nome;
                    this.selectedRow.nome = "";
                }
                this.flagBack = false;
                this.getListaFile();
            }
        },

        async getListaFile() {
            this.loading = true;

            this.selectedRow.compCode = this.codeCartellaOrigine;
            //controllo per cartella FSC e PEFC e FPC
            if (this.selectedRow.compCode == "FSC" || this.selectedRow.compCode == "PEFC" || this.selectedRow.compCode == "FPC") this.selectedRow.nome = this.selectedRow.compCode;

            let res = await getFileCliente(this.selectedRow);
            if (res.data != null) {
                this.listaDati = res.data;
            }
            this.selectedRow.compCode = this.codeCartellaOrigine;
            this.setPosUrl();// setto indirizzo per sapere l'url in cui si sta lavorando
            this.selectedItem = null;
            this.loading = false;
        },

        vaiAllaRadice() {
            this.selectedRow = null;
            this.codeCartellaOrigine = "";
            this.posizioneUrl = "";
            this.pathIndietro = "";
            this.getResources(false);
        },

        async backDirectory() {
            this.loading = true;

            this.selectedItem = null;

            //this.setUrlFile();//controllo se selezionato un file
            //this.$functions.getPathFtp() + "/" + this.posizioneUrl
            //this.posizioneUrl = 

            this.listaDati = [];
            let res = "";
            this.posizioneUrl = this.posizioneUrl.includes('/') ? this.posizioneUrl.slice(0, this.posizioneUrl.lastIndexOf('/')) : ""
            {
                let par = {
                    path: this.radiceConPosizione()
                };
                res = await getFileCliente(par);
            }

            if (res.data != null && res.data.length > 0) {
                this.listaDati = res.data;
                if (this.listaDati[0].path == this.pathOrigine) {
                    this.flagBack = true;
                    this.codeCartellaOrigine = "";
                }

                //ordino cartelle per Ragione Sociale
                this.orderListaCartelle();
            }
            this.selectedRow = null;

            this.loading = false;
        },

        setUrlFile() {
            if (this.selectedRow != null) {
                let path = this.selectedRow.path.split("/");
                let value = path[path.length - 1];
                value = value.split(".");

                if (value.length >= 2) {
                    for (let i = 0; i < path.length - 1; i++) {
                        if (i == 0) this.selectedRow.path = path[i];
                        else this.selectedRow.path = this.selectedRow.path + "/" + path[i];
                    }
                }
            }
        },

        getPath() {
            let url = "";
            let path = this.selectedRow.path.split("\\");
            for (let i = 0; i < path.length - 1; i++) {
                if (i == 0) url = path[i];
                else url = url + "\\" + path[i];
            }
            this.selectedRow.path = url;
        },
        getPathFtp() {
            let url = "";
            let path = this.selectedRow.path.split("/");
            for (let i = 0; i < path.length - 1; i++) {
                if (i == 0) url = path[i];
                else url = url + "/" + path[i];
            }
            this.selectedRow.path = url;
        },

        chiudiDialog(success, error) {
            this.successDir = success;
            this.errorDir = error;
            if (this.successDir)
                setTimeout(() => {
                    this.successDir = false;
                }, 3000);
            else if (this.errorDir)
                setTimeout(() => {
                    this.errorDir = false;
                }, 3000);
            this.dialog = false;
        },

        setPosUrl(value) {
            // Path relativi nel formato "UserFile/<segmenti...>": il primo segmento ("UserFile")
            // va sempre escluso dalla posizione visualizzata/usata per le richieste successive.
            let pos = "";
            if (this.listaDati.length > 0) {
                pos = this.listaDati[0].path.split('/');
                this.posizioneUrl = pos.slice(1, -1).join('/');
            }
            else {
                pos = this.selectedRow.path.split('/');
                this.posizioneUrl = pos.slice(1, pos.length).join('/');
            }
            //serve nel caso si crei una nuova cartella dopo essere tornati indietro con la navigazione
            this.pathIndietro = pos.slice(0, -1).join('/');

            /* if (value == true) this.refreshFlag = true;
            else this.refreshFlag = false; */
        },

        showPermanent(item) {
            if (item.tipo == "folder") this.opzioniFolder = item;
            else this.opzioniFolder = null;
        },

        async SelectOpzioneMenu(item) {
            if (item.Opzione == 1) await this.EliminaDirectory(this.opzioniFolder);
            if (item.Opzione == 2) {
                //controllo se cartella origine cliente
                await this.RenameDirectory(this.opzioniFolder);
            }
            if (item.Opzione == 3) this.apriDialogSposta(this.opzioniFolder);
        },

        apriDialogSposta(elemento) {
            this.elementoDaSpostare = elemento;
            this.dialogSposta = true;
        },

        chiudiDialogSposta() {
            this.dialogSposta = false;
            this.elementoDaSpostare = null;
        },

        spostamentoCompletato() {
            this.chiudiDialogSposta();
            this.getResources(true, false, true);
        },

        async ArchiviaCliente(folder) {
            if (!folder) return;
            let confirm = await this.$confirm.open(
                "Archivia cliente",
                "Spostare l'intera cartella di <b>" + (folder.cliente || folder.nome) + "</b> nell'archivio dei vecchi clienti?" +
                "<br><br>La cartella sparirà da questo elenco: potrai ritrovarla e ripristinarla da \"Archivio vecchi clienti\"."
            );
            if (!confirm) return;

            this.loading = true;
            const res = await archivia_cliente(folder.nome);
            if (res.data === "OK") {
                this.$toast.info("Cliente archiviato");
                this.getResources(true, false, true);
            } else {
                this.$toast.alert(res.data);
            }
            this.loading = false;
        },

        async EliminaDirectory(folder) {
            let str = "";
            if (folder.cliente != "" && folder.cliente != null) str = "Eliminare la cartella: <br><b>" + folder.nome + "</b> di <b>" + folder.cliente + "</b>?<br><br>Tutte le risorse al suo interno andranno perse.";
            else str = "Eliminare la cartella: <br><b>" + folder.nome + "</b>?<br><br>Tutte le risorse al suo interno andranno perse.";

            let confirm = await this.$confirm.open(
                "Elimina",
                str
            );
            if (!confirm) return;

            this.loading = true;

            let par = "?path=" + encodeURIComponent(folder.path);
            let data = {
                nome: folder.nome,
                path: folder.path
            }
            let res = await elimina_cartella(par);//data

            if (res.data == "OK") {
                this.$toast.info("Cartella eliminata");
                this.getResources(true, false, true);
            }
            else
                this.$toast.alert("Errore nell'eliminazione della cartella " + folder.nome);

            this.loading = false;
        },

        async RenameDirectory(folder, value) {
            if (this.dialogRenameDir) {
                this.DirectoryRename = null;
                this.dialogRenameDir = false;
                if (this.selectedRow == null) this.setPathRenameDirBack();
                if (value != -1) await this.getResources(true);//carico dati aggiornati
            }
            else {
                this.DirectoryRename = folder;
                this.dialogRenameDir = true;
            }
        },

        setPathRenameDirBack() {
            if (this.selectedRowSuppBack != null) {
                this.selectedRow = this.selectedRowSuppBack;
                let path = this.selectedRow.path.split("/");
                let pathDir = path.slice(0, -1).join("/");
                this.selectedRow.path = pathDir;
            }
            else this.selectedRow = { path: this.pathIndietro };
        },
    },

    mounted() {
        this.getResources(false);
    },

    watch: {
        file(newVal) {
            if (newVal.length > 0) {
                this.isPulsating = true;
                this.countFile = 0;
                //controllo se si aggiunge il file in drag & drop o con singolo click
                if (newVal.length <= 1) this.fileSupp.push(this.file[0]);
                else {
                    this.fileSupp = [];
                    this.fileSupp = this.file
                }
                //if (this.listaSottoDirectory.length > 0) this.chiudiDialogSceltaDirectory();
                this.countFile = this.fileSupp.length;
            }
            else {
                this.isPulsating = false;
                this.countFile = 0;
                this.fileSupp = [];
            }
        },
    },

    created() {
        this.opzioni = this.opzioniComplete();
    },

    computed: {
        getRole() {
            return this.$store.getters["user/getRole"];
        },

        // La radice (posizioneUrl vuoto) e' per tutti i ruoli la vista iniziale dell'archivio:
        // per admin/auditor l'elenco aziende, per l'utente la propria azienda + le eventuali
        // cartelle di gruppo certificate. Oltre questo punto Indietro/Home vanno disabilitati.
        inRadiceNavigazione() {
            return this.posizioneUrl == "" || this.posizioneUrl == null;
        },

        // True quando ci si trova dentro (a qualunque profondita') una cartella di gruppo condivisa
        // (FSC/PEFC/FPC): calcolato sempre da posizioneUrl, mai impostato a mano, cosi' non puo'
        // restare "sporco" da una navigazione precedente (causa del bug con upload bloccato nella
        // cartella personale dopo aver visitato una cartella di gruppo).
        cartellaSpeciale() {
            if (!this.posizioneUrl) return false;
            const primoSegmento = this.posizioneUrl.split('/')[0];
            return primoSegmento === "FSC" || primoSegmento === "PEFC" || primoSegmento === "FPC";
        },

        disabilitaCaricamento() {
            if (this.getRole == "admin") return false;
            if (this.posizioneUrl == "" || this.posizioneUrl == null) return true;
            return this.cartellaSpeciale;
        },

        mostraFiltriRadice() {
            const inRadice = this.posizioneUrl == "" || this.posizioneUrl == null;
            return inRadice && (this.getRole === "admin" || this.getRole === "auditor");
        },

        listaDatiFiltrata() {
            if (!this.mostraFiltriRadice) return this.listaDati;

            const ricerca = (this.ricercaRagioneSociale || "").toLowerCase().trim();

            return this.listaDati.filter((item) => {
                if (ricerca && !(item.cliente || "").toLowerCase().includes(ricerca)) return false;
                if (this.filtroCertificazioni.length > 0 && !this.filtroCertificazioni.some((cert) => item[cert]))
                    return false;
                return true;
            });
        },
    }
};
</script>

<style scoped>
.zoom-card {
    transition: transform 0.3s ease;
}

.zoom-card:hover {
    transform: scale(1.1);
}

@keyframes pulsate {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

.pulsating {
    animation: pulsate 1s infinite;
}
</style>
